
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store"; // Import your configured store
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
// import "./styles/font.css";
import { ToastProvider } from './components/ui/Toast'; // Import ToastProvider
import { HelmetProvider } from 'react-helmet-async';
import { CurrencyProvider } from './features/currency/CurrencyContext';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ToastProvider>
          <CurrencyProvider>
            <App />
          </CurrencyProvider>
        </ToastProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
